import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';
import { api } from '@/utils/api';
interface MeasurementType {
	id: number;
	name: string;
	description: string | null;
	swmmParameter: string | null;
	defaultV?: boolean;
}

interface MeasurementTypesState {
	fetching: boolean;
	array: MeasurementType[];
	current: Record<string, any>;
	error?: string;
}

// Estado inicial de `measurementTypes`
const initialState: MeasurementTypesState = {
	fetching: false,
	array: [],
	current: {},
};

const measurementTypesSlice = createSlice({
	name: 'measurementTypes',
	initialState,
	reducers: {
		getMeasurementTypes(state) {
			state.fetching = true;
		},
		getMeasurementTypesSuccess(state, action: PayloadAction<MeasurementType[]>) {
			state.fetching = false;
			state.array = action.payload.map((t) => ({
				id: t.id,
				name: t.name,
				description: t.description ?? null,
				swmmParameter: t.swmmParameter ?? null,
				defaultV: t.defaultV ?? false,
			}));
		},
		getMeasurementTypesError(state, action: PayloadAction<string>) {
			state.fetching = false;
			state.error = action.payload;
		},
	},
});

export const { getMeasurementTypes, getMeasurementTypesSuccess, getMeasurementTypesError } =
	measurementTypesSlice.actions;
export default measurementTypesSlice.reducer;

// Thunk para realizar la acción de obtener los tipos de medida
export const getTypesAction = (infraType?: number | string) => async (dispatch: AppDispatch) => {
	dispatch(getMeasurementTypes());
	try {
		const res = await api.get(
			`${import.meta.env.VITE_APP_BASE_URL}/measurements/parameters/types${
				infraType != null ? `?assetTypeId=${infraType}` : ''
			}`,
		);
		dispatch(getMeasurementTypesSuccess(res.data));
	} catch (err: any) {
		console.error(err);
		dispatch(getMeasurementTypesError(err.response?.message || 'Error desconocido'));
	}
};
